import React, { useState, useEffect } from "react";
import axios from "axios";
import { parsePosition } from "helper/getLocation";

const DEF_LOCATION = "(36.766188457702526,10.11430576142565)";

const AddressFetcher = ({
  lat = null,
  lon = null,
  position = null,
  showAddress = true,
  children,
  onChange,
}) => {
  const [address, setAddress] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  if (position) {
    lat = parsePosition(position)[0];
    lon = parsePosition(position)[1];
  }

  useEffect(() => {
    const fetchAddress = async () => {
      if (!lat || !lon) return;
      setLoading(true);
      try {
        const url = `https://photon.taxiora.net/reverse?lat=${lat}&lon=${lon}`;
        const response = await axios.get(url);
        if (response.data && response.data.features.length > 0) {
          const newAddress = response.data.features[0].properties.name;
          setAddress(newAddress);
          if (onChange) onChange({ lat: lat, lng: lon, address: newAddress });
        } else {
          setAddress("Adresse non trouvée");
        }
      } catch (err) {
        console.error("Error fetching address:", err);
        setError("Erreur lors de la récupération de l'adresse");
      } finally {
        setLoading(false);
      }
    };

    fetchAddress();
  }, [lat, lon]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div
      style={{
        display: "flex",
        fontSize: "18px",
        fontWeight: "bold",
        flexWrap: "wrap",
        gap: "1rem",
      }}
    >
      {children ? children(address) : showAddress && <div>{address}</div>}
    </div>
  );
};

export default AddressFetcher;
